import CryptoJS from 'crypto-js';
import setting from './config.util';
import axios from 'axios';
import { getCookie } from './cookies.util';
import {
  ensureClockSynced,
  getServerNow,
  syncServerClock,
} from './serverClock.util';

const instance = axios.create({
  baseURL: '',
});

instance.interceptors.request.use(
  async (request) => {
    const accessToken = getCookie('token') || '';
    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }
    await ensureClockSynced();
    const createdAt = getServerNow();
    const password = `${setting.APP_ENCRYPTION_KEY}${createdAt}`;
    const apiKey = CryptoJS.AES.encrypt(
      password,
      `${setting.APP_ENCRYPTION_KEY}`,
      {
        iv: setting.APP_IV as any,
      },
    ).toString();
    request.headers['Content-Type'] = 'application/json';
    request.headers['Access-Control-Allow-Methods'] =
      'GET, PUT, POST, DELETE, OPTIONS';
    request.headers['appType'] = 'Customer';
    request.headers['createdAt'] = createdAt;
    request.headers['apikey'] = apiKey;
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// A 401 can mean the device clock is off (the apikey embeds `createdAt`).
// Re-sync the clock and retry once if the correction was significant.
instance.interceptors.response.use(undefined, async (error) => {
  const config = error?.config;
  if (error?.response?.status !== 401 || !config || config._clockRetried) {
    return Promise.reject(error);
  }

  const clockCorrected = await syncServerClock();
  if (!clockCorrected) return Promise.reject(error);

  config._clockRetried = true;
  return instance(config);
});

export default instance;
